import React, { useState, useEffect } from 'react';
import Table from './Table';

import EnterpriseContext from '../../../contexts/EnterpriseContext';

export default function Index({ userToken }) {
  return (
    <EnterpriseContext>
      <div className="wrapper_assestment invite_wrapper">
        <div className="invite_header">
          <div className="text_h3">Enterprises</div>
        </div>
        <div className="ibox-content mt20">
          <Table userToken={userToken} />
        </div>
      </div>
    </EnterpriseContext>
  );
}
